try {
// ============================================================
// app.js — khung SPA + vẽ các module (kế thừa giao diện THCS Bạch Liêu)
// Khi nối Supabase: du-lieu-sql.js ghi đè các mảng dữ liệu rồi gọi lại
// veTatCa() — không sửa file này.
// ============================================================
(function () {
  'use strict';

  function $(s, p) { return (p || document).querySelector(s); }
  function $$(s, p) { return Array.prototype.slice.call((p || document).querySelectorAll(s)); }
  function boDau(s) {
    return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D').toLowerCase();
  }
  function thoatHTML(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  window.boDau = boDau;
  window.thoatHTML = thoatHTML;

  // da_dong: hồ sơ ĐÃ ĐÓNG theo Luật 123/2025 (sql/46 cho phép, sql/48 di trú
  // đặt) — không có nhãn thì badge in "undefined". Máy quét Drive không được
  // đụng vào trạng thái này theo cả hai chiều.
  var ST_LABEL = { co: 'Đã có', dang: 'Đang cập nhật', chua: 'Chưa có', da_dong: 'Đã đóng' };
  window.ST_LABEL = ST_LABEL;

  // ── Thông báo nổi (toast) ──
  var toastTimer = null;
  window.notify = function (msg) {
    var t = $('#toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 3600);
  };

  // ── Điều hướng: hero chỉ hiện ở Trang chủ ──
  function chuyenManHinh(ma) {
    $$('.man-hinh').forEach(function (m) { m.classList.toggle('hien', m.id === 'mh-' + ma); });
    // Màn con không có nút riêng trên menu thì tô sáng nút của nhánh cha
    var nutSang = (ma === 'cbgv') ? 'hoso' : (ma === 'sochunhiem' || ma === 'sodaubai') ? 'hocsinh' : ma;
    $$('nav.menu button').forEach(function (b) {
      b.classList.toggle('dang-chon', b.getAttribute('data-di') === nutSang);
    });
    $('#hero').style.display = (ma === 'home') ? '' : 'none';
    dongBangMenu();          // chọn xong thì bảng ☰ tự đóng
    window.scrollTo(0, 0);
  }
  window.chuyenManHinh = chuyenManHinh;

  // ── Nút ☰ (chỉ hiện dưới 1000px, CSS lo phần ẩn/hiện) ──
  function dongBangMenu() {
    var khu = $('#khu-dieu-huong'), nut = $('#nut-menu');
    if (!khu || !nut) return;
    khu.classList.remove('mo');
    nut.setAttribute('aria-expanded', 'false');
  }
  (function ganNutMenu() {
    var khu = $('#khu-dieu-huong'), nut = $('#nut-menu');
    if (!khu || !nut) return;
    nut.addEventListener('click', function (e) {
      e.stopPropagation();
      var mo = khu.classList.toggle('mo');
      nut.setAttribute('aria-expanded', mo ? 'true' : 'false');
    });
    // Bấm ra ngoài thì đóng. Chip tài khoản bên trong bảng đã stopPropagation
    // nên mở hộp tài khoản không làm sập cả bảng.
    document.addEventListener('click', function (e) {
      if (khu.contains(e.target) || e.target === nut) return;
      dongBangMenu();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') dongBangMenu();
    });
  })();

  // ── Đếm chung ──
  // Hồ sơ ĐÃ ĐÓNG (hết căn cứ / gộp vào mã khác) đứng NGOÀI mẫu số — trước 1/10/2026
  // nó bị tính là "Chưa có" nên đóng bớt hồ sơ theo danh mục tinh gọn lại làm TỤT tỉ lệ.
  function demTrangThai(ds) {
    var co = 0, dang = 0, dong = 0;
    ds.forEach(function (h) { if (h.tt === 'co') co++; else if (h.tt === 'dang') dang++; else if (h.tt === 'da_dong') dong++; });
    return { co: co, dang: dang, dong: dong, chua: ds.length - co - dang - dong, tong: ds.length - dong };
  }

  // ── Trang chủ + thống kê màn Hồ sơ ──
  function veThongKe() {
    var d = demTrangThai(window.HO_SO);
    $('#tk-tong').textContent = d.tong;
    // Đếm thật từ dữ liệu, KHÔNG viết số cứng vào HTML — thêm/bớt một đầu hồ sơ
    // là chữ trên trang chủ tự đúng theo.
    $('#chip-ho-so').textContent = (window.BO_PHAN || []).length + ' bộ phận · ' + d.tong + ' danh mục';
    // Quy mô: hỏi window.quyMoTruong() chứ ĐỪNG đọc thẳng CAU_HINH.SO_LOP —
    // hàm đó ưu tiên số đếm thật từ danh sách lớp, chỉ lùi về ô admin tự khai
    // khi trường chưa nạp danh sách. Xem khối chú thích ở js/du-lieu-sql.js.
    // Trường chưa có cả hai thì để dấu gạch, ĐỪNG in số 0. "0 lớp · 0 học
    // sinh" đọc ra như trường không có học sinh nào, trong khi sự thật chỉ là
    // chưa ai điền. Dấu gạch nói đúng: chưa có số.
    var qm = window.quyMoTruong ? window.quyMoTruong()
      : { lop: window.CAU_HINH.SO_LOP, hs: window.CAU_HINH.SO_HOC_SINH, khoi: 0 };
    $('#chip-so-lop').textContent = qm.lop ? qm.lop + ' lớp' : 'chưa khai quy mô';
    $('#tk-lop').textContent = qm.lop || '–';
    // Số khối KHÔNG ghi cứng "5 khối lớp" trong HTML nữa. Ghi cứng thì trường
    // chưa nạp danh sách vẫn thấy "– lớp · 5 khối lớp" — một con số app tự bịa;
    // và app còn dùng cho cấp khác thì 5 lại sai hẳn. Chưa đếm được thì im.
    var oLopNhan = document.getElementById('tk-lop-nhan');
    if (oLopNhan) oLopNhan.textContent = qm.khoi ? 'lớp · ' + qm.khoi + ' khối lớp' : 'lớp';
    // Vẽ lại hai dòng chữ này sau khi nạp cấu hình từ CSDL — chúng được đặt
    // lần đầu lúc DOMContentLoaded, tức là TRƯỚC khi đọc bảng cau_hinh.
    $('#dien-nam-hoc').textContent = window.CAU_HINH.NAM_HOC;
    $('#tk-hoc-sinh').textContent = qm.hs ? Number(qm.hs).toLocaleString('vi-VN') : '–';
    $('#hs-tong').textContent = d.tong;
    $('#hs-co').textContent = d.co;
    // Chắn phép chia cho 0: kho hồ sơ rỗng (hoặc đọc lỗi) thì d.tong = 0 →
    // 0/0 ra NaN, thầy cô nhìn thấy dòng "Đã có — NaN%" và thanh tiến độ dài
    // vô định. Dòng 168 dưới đây vốn đã chắn, chỗ này thì chưa.
    var ptCo = d.tong ? Math.round(d.co * 100 / d.tong) : 0;
    $('#hs-co-nhan').textContent = d.tong ? 'Đã có — ' + ptCo + '%' : 'Chưa có dữ liệu';
    $('#hs-dang').textContent = d.dang;
    $('#hs-chua').textContent = d.chua;
    $('#td-tong').style.width = '100%';
    $('#td-co').style.width = ptCo + '%';
  }

  // ════════════════════════════════════════════════════════════
  // MODULE 1 · QUẢN TRỊ HỒ SƠ — thẻ bộ phận → lớp phủ chi tiết
  // (kế thừa giao diện danh mục minh chứng của THCS Bạch Liêu)
  // ════════════════════════════════════════════════════════════
  var tuKhoa = '';
  var locTT = 'tatca';
  var boPhanDangMo = null; // soTT bộ phận đang mở trong lớp phủ

  // BGH / quản trị (hoặc bản xem thử chưa nối CSDL). Rà phân quyền 28/9/2026
  // (sổ dự án mục 100): phiếu giao việc, ghi trạng thái rà Drive, thẻ Quản trị
  // ở trang chủ chỉ dành cho nhóm này — máy chủ dùng đúng la_admin().
  function laQuanTriApp() {
    var u = window.NGUOI_DUNG;
    if (!window.MAY_CHU) return !u;
    return !!u && (u.vai_tro === 'admin' || u.vai_tro === 'ban_giam_hieu');
  }
  // Ẩn/hiện các lối vào chỉ dành cho BGH theo người đang đăng nhập. Gọi lại
  // sau đăng nhập (supabase-ket-noi.js) và khi 'dangnhap-xong'.
  window.apQuyenGiaoDien = function () {
    var the = document.getElementById('the-quan-tri');
    if (the) the.style.display = laQuanTriApp() ? '' : 'none';
  };
  document.addEventListener('dangnhap-xong', function () { window.apQuyenGiaoDien(); });

  function banGhi(ma) { // bản ghi đầy đủ trong CSDL (null ở chế độ xem thử)
    return (window.HS_BAN_GHI && window.HS_BAN_GHI[ma]) || null;
  }

  // Mục "Sổ chủ nhiệm" (H08, MC.3.4.08 bên tiểu học): nút mở sổ điện tử
  // (js/so-chu-nhiem.js) cạnh 📂 Drive — 29/9/2026. Nhận theo mã HOẶC tên vì
  // danh mục THCS mã khác. Chỉ hiện với người mở được sổ: BGH/QT, GVCN, tổ trưởng
  // được giao (window.SCN_QUYEN do lối tắt trang chủ điền ngay sau đăng nhập).
  function laSoChuNhiem(h) { return h.ma === 'MC.3.4.08' || /^sổ chủ nhiệm$/i.test(String(h.ten || '').trim()); }
  function duocMoSoCN() {
    if (!window.MAY_CHU) return true;   // xem thử
    var vt = (window.NGUOI_DUNG || {}).vai_tro || '', q = window.SCN_QUYEN || {};
    return vt === 'admin' || vt === 'ban_giam_hieu' || !!q.gvcn || !!q.toKT;
  }
  window.moSoChuNhiemDienTu = function () {
    if (window.dongLopPhu) { try { window.dongLopPhu(); } catch (e) { /* lớp phủ chưa mở */ } }
    if (window.SO_CHU_NHIEM && window.SO_CHU_NHIEM.moLop) window.SO_CHU_NHIEM.moLop();
    else chuyenManHinh('sochunhiem');
  };

  function idThuMucDrive(link) {
    if (!/^https?:\/\/drive\.google\.com\//.test(link || '')) return '';
    var m = /\/folders\/([A-Za-z0-9_-]{10,})/.exec(link) || /[?&]id=([A-Za-z0-9_-]{10,})/.exec(link);
    return m ? m[1] : '';
  }
  function taoTmDuoc() {
    return !!(window.MAY_CHU && laQuanTriApp() && window.KY_HO_SO && window.KY_HO_SO.bat() && window.KY_HO_SO.taoThuMuc);
  }
  function kyHoSoDuoc(link) {
    return !!(window.MAY_CHU && laQuanTriApp() && window.KY_HO_SO && window.KY_HO_SO.bat() && idThuMucDrive(link));
  }

  // Một dòng minh chứng trong bảng
  function dongBang(h, hienHop) {
    var hs = banGhi(h.ma);
    var link = (hs && hs.link_drive) || h.link || '';
    var suaDuoc = window.coQuyenSuaHoSo ? window.coQuyenSuaHoSo(h.ma) : false;
    return '<tr data-ma="' + thoatHTML(h.ma) + '">' +
      // KHÔNG bày mã cũ dưới mã mới nữa — thầy Chung bỏ 21/8/2026: danh mục đã
      // chuyển hẳn sang mã TT57, bày hai mã đọc ra như bảng chuyển mã. Dữ liệu
      // ma_cu vẫn GIỮ trong CSDL (di trú sql/47-48 và đối chiếu hồ sơ giấy cần)
      // và ô tìm kiếm vẫn tìm ra theo mã cũ — chỉ thôi hiển thị.
      '<td class="code">' + thoatHTML(h.ma) + '</td>' +
      '<td class="rname">' + thoatHTML(h.ten) +
      (hienHop ? '<span class="hop-phu">' + thoatHTML((window.HOP[h.hop] || {}).ten || h.hop || '') + '</span>' : '') +
      '<span class="crits">' + (h.tc || []).map(function (c) {
        return '<span class="tag-crit" onclick="event.stopPropagation();xemTieuChi(\'' + c + '\')">Tiêu chí ' + c + '</span>';
      }).join('') + '</span></td>' +
      '<td class="owner">' + thoatHTML(h.phuTrach || (window.HOP[h.hop] || {}).phuTrach || '—') + '</td>' +
      '<td class="tdst"><span class="st st-' + h.tt + '">' + ST_LABEL[h.tt] + '</span>' +
      // KHÔNG gắn class .drive: toMau() lấy phần tử .drive ĐẦU TIÊN trong dòng để tô 📂
      (laSoChuNhiem(h) && duocMoSoCN()
        ? '<button type="button" class="mo-so-dt" title="Mở sổ chủ nhiệm điện tử" onclick="event.stopPropagation();window.moSoChuNhiemDienTu()">📓 Mở sổ</button>'
        : '') +
      (link
        ? '<a class="drive" href="' + thoatHTML(link) + '" target="_blank" rel="noopener" title="Mở thư mục trên Drive" onclick="event.stopPropagation()">📂</a>'
        : taoTmDuoc()
        // Quản trị, BGH: bấm 📂 xám là tạo thư mục (js/ky-ho-so.js taoThuMuc, 30/10/2026)
        ? '<button class="drive mo tao-tm" title="Chưa gán thư mục — bấm để tạo thư mục trên Drive"' +
          ' onclick="event.stopPropagation();window.KY_HO_SO.taoThuMuc(\'ho_so\',\'' + thoatHTML(h.ma) + '\',\'' +
          thoatHTML(h.ma + ' · ' + String(h.ten || '').replace(/['\\]/g, ' ')) + '\',this)">📂</button>'
        : '<button class="drive mo" title="Chưa gán thư mục Drive" onclick="event.stopPropagation();window.notify(\'Hồ sơ này chưa được gán thư mục trên Drive.\')">📂</button>') +
      (suaDuoc ? '<button class="drive hs-sua" title="Sửa hồ sơ này" onclick="event.stopPropagation();moSuaHoSo(\'' + thoatHTML(h.ma) + '\')">✏️</button>' : '') +
      // ✍ Ký hồ sơ của trường (js/ky-ho-so.js, thầy Chung 30/10/2026): Hiệu trưởng,
      // Phó Hiệu trưởng ký + đóng dấu PDF trong thư mục hồ sơ. Dịch vụ ký kiểm lại quyền.
      (kyHoSoDuoc(link)
        ? '<button type="button" class="drive hs-ky" title="Ký, đóng dấu tệp PDF trong hồ sơ này" data-ky-loai="ho_so"' +
          ' data-ky-thu="' + thoatHTML(idThuMucDrive(link)) + '" data-ky-ten="' + thoatHTML(h.ma + ' · ' + h.ten) + '"' +
          // stopPropagation chặn cả lối bắt chung ở document (ky-ho-so.js) → gọi thẳng
          ' onclick="event.stopPropagation();window.KY_HO_SO&&window.KY_HO_SO.moTu(this)">✍</button>'
        : '') +
      '</td></tr>';
  }

  // Lưới 5 thẻ bộ phận (mặc định của màn Hồ sơ)
  function veHoSo() {
    var vung = $('#vung-hop');
    var tim = boDau(tuKhoa);

    // Đang gõ tìm hoặc lọc trạng thái → bảng phẳng toàn trường
    if (tim || locTT !== 'tatca') {
      var kq = window.HO_SO.filter(function (h) {
        if (locTT !== 'tatca' && h.tt !== locTT) return false;
        if (!tim) return true;
        var hop = window.HOP[h.hop] || {};
        return boDau(h.ten + ' ' + h.ma + ' ' + h.maCu + ' ' + hop.ten + ' ' + (h.phuTrach || hop.phuTrach)).indexOf(tim) >= 0;
      });
      vung.innerHTML = kq.length
        ? '<div class="sub open"><div class="sub-body" style="display:block"><table class="rec-tbl"><thead><tr>' +
          '<th style="width:120px">Mã hồ sơ</th><th>Tên hồ sơ</th>' +
          '<th style="width:170px">Người phụ trách</th><th style="width:190px;text-align:right">Trạng thái</th></tr></thead><tbody>' +
          kq.map(function (h) { return dongBang(h, true); }).join('') + '</tbody></table></div></div>'
        : '<div class="the-thong-bao">Không tìm thấy hồ sơ phù hợp.</div>';
      return;
    }

    // Mặc định → 5 thẻ bộ phận
    vung.innerHTML = '<div class="cat-grid">' + window.BO_PHAN.map(function (bp) {
      var ds = window.HO_SO.filter(function (h) { return bp.hop.indexOf(h.hop) >= 0; });
      var d = demTrangThai(ds);
      var pt = d.tong ? Math.round(d.co * 100 / d.tong) : 0;
      var moTa = bp.hop.map(function (m) { return (window.HOP[m] || {}).ten; }).join(' · ');
      return '<button class="cat" onclick="moBoPhan(' + bp.soTT + ')">' +
        '<div class="cat-top"><div class="ic">' + String(bp.soTT).padStart(2, '0') + '</div>' +
        '<div class="tt"><div class="no">BỘ PHẬN ' + bp.icon + '</div><h3>' + thoatHTML(bp.ten) + '</h3></div></div>' +
        '<div class="cat-body"><p>' + thoatHTML(moTa) + '</p>' +
        '<div class="prog"><i style="width:' + pt + '%"></i></div>' +
        '<div class="cat-foot" style="margin-top:10px"><span class="cat-cnt">' + d.co + '/' + d.tong + ' hồ sơ đã có</span>' +
        '<span class="cat-open">Mở danh mục →</span></div></div></button>';
    }).join('') +
      // Thẻ thứ 6: lối vào hồ sơ đội ngũ
      '<button class="cat" onclick="chuyenManHinh(\'cbgv\')">' +
      '<div class="cat-top"><div class="ic">👥</div>' +
      '<div class="tt"><div class="no">ĐỘI NGŨ</div><h3>Hồ sơ CBGV – NV</h3></div></div>' +
      '<div class="cat-body"><p>Hồ sơ cá nhân của ban giám hiệu, giáo viên, nhân viên và đường dẫn tới hồ sơ trên Drive.</p>' +
      '<div class="prog" style="visibility:hidden"><i style="width:0"></i></div>' +
      '<div class="cat-foot" style="margin-top:10px"><span class="cat-cnt">Toàn trường</span>' +
      '<span class="cat-open">Xem đội ngũ →</span></div></div></button>' +
      '</div>';
  }

  // ── Kiểm tra ngay: đếm tệp THẬT trên Drive của cả bộ phận đang mở ──
  // Thiết kế gốc sql/07-kiem-tra-drive.sql: gửi {mã hồ sơ: id thư mục} cho
  // dịch vụ Apps Script của trường (quan-tri/kiem-tra-tep-drive.gs — URL nằm
  // ở cau_hinh.link_kiem_tra_drive), nhận về {mã: số tệp}, rồi:
  //   · báo bao nhiêu hồ sơ CÓ TỆP ngay dưới dải tổng
  //   · icon 📂 từng dòng: SÁNG = có tệp · XÁM = thư mục trống / không kiểm được
  //   · gọi RPC cap_nhat_tu_drive (sql/62) đồng bộ trạng thái HAI CHIỀU —
  //     "DRIVE LÀ CHUẨN", thầy Chung chốt 26/8/2026: có tệp → 'co', thư mục
  //     trống → HẠ về 'chua' (kể cả từ 'dang'); không kiểm được thì giữ nguyên.
  //     Nhờ vậy con số x/y, badge "Đã có/Chưa có" và icon vàng/xám kể CÙNG một
  //     câu chuyện — hết cảnh "44/57 đã khai" đứng cạnh "1/57 trên Drive" như
  //     bài nghiệm thu Châu Đình. RPC chỉ admin/BGH chạy được; người khác bấm
  //     vẫn xem kết quả đếm, app nói rõ là trạng thái chưa được ghi lại.
  // Gọi theo LÔ 20 thư mục: mỗi thư mục ngốn 1-2 giây Drive API phía dịch vụ,
  // gửi cả bộ phận một gói là chạm trần 6 phút Apps Script và mất trắng kết
  // quả (soát đối kháng 26/8). ⚠️ fetch KHÔNG đặt header Content-Type — đặt
  // application/json là dính preflight OPTIONS mà Apps Script không trả lời
  // được, CORS chặn toàn bộ.
  // Chưa cấu hình dịch vụ, hoặc đang xem thử → lùi về đếm theo trạng thái đã
  // lưu: icon vẫn đổi màu theo "Đã có / Chưa có", chỉ không có số tệp thật.
  var luotKiemTra = 0;   // mã lượt chạy: bấm lượt mới là mọi callback lượt cũ câm
  window.kiemTraBoPhan = function (soTT) {
    var bp = window.BO_PHAN.filter(function (b) { return b.soTT === soTT; })[0];
    if (!bp || !$('#kq-kiem-tra')) return;
    var ds = window.HO_SO.filter(function (h) { return bp.hop.indexOf(h.hop) >= 0; });
    var luot = ++luotKiemTra;
    // Còn sống = vẫn là lượt bấm mới nhất VÀ lớp phủ vẫn mở đúng bộ phận này.
    // Soát đối kháng 26/8 bắt được hai ca thiếu chốt này: timeout lượt cũ đè
    // kết quả đúng của lượt mới, và RPC về muộn ghi số bộ phận cũ lên dải
    // tổng của bộ phận vừa mở.
    function conSong() { return luot === luotKiemTra && boPhanDangMo === soTT; }

    // Nhận diện id thư mục Drive trong link (…/folders/<id> hoặc …?id=<id>,
    // id= không cần đứng ngay sau dấu hỏi). Neo đúng tên miền drive.google.com.
    function layIdThuMuc(link) {
      if (!/^https?:\/\/drive\.google\.com\//.test(link)) return null;
      var m = /\/folders\/([A-Za-z0-9_-]{10,})/.exec(link) ||
              /[?&]id=([A-Za-z0-9_-]{10,})/.exec(link);
      return m ? m[1] : null;
    }

    var quet = {}, linkCua = {}, troNoiBo = 0, linkNgoai = 0, chuaGan = 0;
    ds.forEach(function (h) {
      var bg = (window.HS_BAN_GHI && window.HS_BAN_GHI[h.ma]) || {};
      var link = ((bg.link_drive || h.link) || '').trim();
      linkCua[h.ma] = link;
      var id = link ? layIdThuMuc(link) : null;
      if (id) quet[h.ma] = id;
      else if (!link) { if (h.tt !== 'da_dong') chuaGan++; }   // hồ sơ đã đóng không cần thư mục
      else if (link.indexOf('#') >= 0) troNoiBo++;   // đầu mục trỏ (…/#cbgv)
      else linkNgoai++;                              // Docs/Sheets/tệp đơn… — không quét được
    });
    var cacMa = Object.keys(quet);

    // Tô icon 📂 từng dòng. kq = {ma: số tệp} khi quét Drive; null khi lùi về
    // trạng thái đã lưu. (Chỉ chọn icon thư mục — nút ✏ cũng mang class .drive.)
    function toMau(kq) {
      $$('#lp-than tr[data-ma]').forEach(function (tr) {
        var ma = tr.getAttribute('data-ma');
        var h = null;
        ds.forEach(function (x) { if (x.ma === ma) h = x; });
        if (!h) return;
        var ic = $('a.drive, button.drive:not(.hs-sua):not(.hs-ky)', tr);
        if (!ic) return;
        ic.classList.remove('xam');
        if (!linkCua[ma]) return;                       // chưa gán — .mo đã làm mờ sẵn
        if (kq && quet[ma] != null) {
          var n = Number(kq[ma]);
          if (n > 0) ic.title = 'Mở thư mục trên Drive — ' + (n >= 50 ? '50+' : n) + ' tệp';
          else if (n === 0) { ic.classList.add('xam'); ic.title = 'Thư mục trên Drive đang TRỐNG'; }
          else { ic.classList.add('xam'); ic.title = 'Không kiểm được thư mục (link hỏng, nằm ngoài kho minh chứng, hoặc lượt quét bị cắt)'; }
        } else if (kq) {
          ic.title = linkCua[ma].indexOf('#') >= 0
            ? 'Trỏ trang nội bộ của app — không quét Drive'
            : 'Link không phải thư mục Drive — không quét được';
        } else if (h.tt !== 'co') {
          ic.classList.add('xam');
          ic.title = 'Mở thư mục trên Drive — hồ sơ đang ghi "' + ST_LABEL[h.tt] + '"';
        }
      });
    }

    function dong(chu) {
      if (!conSong()) return;
      var vung = $('#kq-kiem-tra');   // hỏi lại mỗi lần: lớp phủ có thể vừa vẽ lại
      if (!vung) return;
      vung.innerHTML = '<div style="margin:10px 0 14px"><div class="nhan-nho">' + chu + '</div></div>';
      vung.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    function khoaNut(khoa) {
      // Lượt CHẾT không được MỞ khoá: callback lượt cũ về muộn mà mở khoá là
      // bật lại nút của lượt đang chạy — bấm được lần nữa thành hai chuỗi
      // quét song song (soát đối kháng 26/8).
      if (!khoa && luot !== luotKiemTra) return;
      var nut = $('.sheet-sum .nut-kiem-tra');
      if (nut) nut.disabled = !!khoa;
    }

    var duoiChu = (troNoiBo ? ' · ' + troNoiBo + ' hồ sơ trỏ trang nội bộ' : '') +
      (linkNgoai ? ' · ' + linkNgoai + ' hồ sơ link ngoài Drive (không quét)' : '') +
      (chuaGan ? ' · ' + chuaGan + ' hồ sơ chưa gán thư mục' : '');

    // ── Không quét được (xem thử / chưa cấu hình) → đếm theo trạng thái đã lưu
    var diaChi = String((window.CAU_HINH || {}).LINK_KIEM_TRA_DRIVE || '').trim();
    // Trường chưa dựng dịch vụ đếm riêng nhưng đã có dịch vụ KÝ HỒ SƠ (cùng Gmail chủ
    // cây, apps-script/ky-ho-so-drive.gs việc 'dem') → đếm qua đó. Thầy Chung 30/10
    // (QC2): "Kiểm tra ngay" chỉ ra 0/41 theo trạng thái đã lưu dù Drive đã có tệp.
    var quaKy = !diaChi && !!(window.KY_HO_SO && window.KY_HO_SO.bat() && window.KY_HO_SO.demTep);
    if (!window.DA_NOI || (!diaChi && !quaKy) || !cacMa.length) {
      var d = demTrangThai(ds);
      toMau(null);
      dong('📂 Theo trạng thái đã lưu: <b>' + d.co + '/' + d.tong + '</b> đã có hồ sơ — icon thư mục xám là hồ sơ chưa có.' + duoiChu +
        // Thầy Chung 17/10/2026: bỏ dòng hướng dẫn kỹ thuật (tên tệp .gs, khoá cấu hình) — người dùng không cần thấy.
        (!window.DA_NOI ? '<br><i>Đang xem dữ liệu mẫu nên không quét Drive thật.</i>' : ''));
      return;
    }

    // ── Quét thật: hỏi dịch vụ đếm tệp của trường, tuần tự từng lô ──
    var LO = 20, kqGop = {};
    khoaNut(true);

    function goiLo(tu) {
      if (!conSong()) return khoaNut(false);
      if (tu >= cacMa.length) return hoanTat();
      dong('⏳ Đang đếm tệp trên Drive… ' + tu + '/' + cacMa.length + ' thư mục' +
        (cacMa.length > LO ? ' (lô ' + (Math.floor(tu / LO) + 1) + '/' + Math.ceil(cacMa.length / LO) + ')' : ''));
      var goi = {};
      cacMa.slice(tu, tu + LO).forEach(function (ma) { goi[ma] = quet[ma]; });

      var hen = null;
      var qua = new Promise(function (_, tuChoi) {
        hen = setTimeout(function () { tuChoi(new Error('dịch vụ không trả lời sau 100 giây')); }, 100000);
      });
      var hoi = quaKy
        ? window.KY_HO_SO.demTep(goi)
        : fetch(diaChi, { method: 'POST', body: JSON.stringify(goi) }).then(function (r) {
          if (!r.ok) throw new Error('dịch vụ trả mã ' + r.status);
          return r.json().catch(function () {
            throw new Error('dịch vụ trả về không phải JSON — kiểm bản triển khai Apps Script');
          });
        });
      Promise.race([hoi, qua])
        .then(function (kq) {
          clearTimeout(hen);
          if (!conSong()) return khoaNut(false);
          if (kq && kq.loi) throw new Error(kq.loi === 'sai_khoa' ? 'sai khóa dịch vụ (?k=)' : 'dịch vụ trả dữ liệu hỏng');
          Object.keys(goi).forEach(function (ma) { if (kq && kq[ma] != null) kqGop[ma] = kq[ma]; });
          goiLo(tu + LO);
        })
        .catch(function (e) {
          clearTimeout(hen);
          if (!conSong()) return khoaNut(false);
          khoaNut(false);
          dong('⚠️ Không gọi được dịch vụ đếm tệp: ' + thoatHTML((e && e.message) || 'lỗi mạng') +
            (quaKy ? '' : '.<br><i>Kiểm lại URL + khóa trong cấu hình <code>link_kiem_tra_drive</code>, và bản triển khai Apps Script (Who has access: Anyone).</i>'));
        });
    }

    function hoanTat() {
      khoaNut(false);
      var coTep = 0, soHong = 0;
      cacMa.forEach(function (ma) {
        var n = Number(kqGop[ma]);   // thiếu trong trả lời (lượt quét bị cắt) → NaN → hỏng
        if (n > 0) coTep++;
        else if (n !== 0) { soHong++; if (kqGop[ma] == null) kqGop[ma] = -1; }
      });
      toMau(kqGop);
      // Kết quả gọn MỘT câu, chữ nghĩa thầy Chung chốt 27/8: "Kiểm tra lúc
      // HH:MM: X/Y đã có hồ sơ". Số thư mục trống KHÔNG nhắc lại — icon 📂
      // xám từng dòng đã nói thay; chỉ nêu phần KHÔNG kiểm được (hiếm, cần
      // biết vì trạng thái các dòng ấy giữ nguyên).
      var gio = new Date();
      var luc = ('0' + gio.getHours()).slice(-2) + ':' + ('0' + gio.getMinutes()).slice(-2);
      // Thầy Chung 30/10/2026: CHỈ một câu "Kiểm tra lúc HH:MM: X/Y đã có hồ sơ" —
      // bỏ phần "N thư mục không kiểm được", hồ sơ trỏ nội bộ / link ngoài, dòng nghiêng.
      dong('Kiểm tra lúc ' + luc + ': <b>' + coTep + '/' + cacMa.length + '</b> đã có hồ sơ');

      // ── DRIVE LÀ CHUẨN: đồng bộ trạng thái HAI CHIỀU theo kết quả đếm ──
      // Có tệp → 'co'; 0 tệp → 'chua'; không kiểm được (-1/NaN) KHÔNG gửi lên.
      // Gửi TOÀN BỘ kết quả đếm được, KHÔNG lọc theo trạng thái trên máy: bộ
      // nhớ máy có thể lệch CSDL (người khác vừa sửa tay ở máy họ), lọc theo
      // nó là bỏ sót đúng dòng đang lệch mà vẫn báo "đã cập nhật". RPC có sẵn
      // where <> nên gửi thừa vô hại (soát đối kháng 26/8). Hồ sơ ĐÃ ĐÓNG
      // (da_dong, Luật 123/2025) đứng ngoài mọi chiều — SQL cũng tự chặn,
      // đây là lớp một.
      var doi = {}, demDoi = 0;
      ds.forEach(function (h) {
        var n = Number(kqGop[h.ma]);
        if (h.tt === 'da_dong') return;
        if (n >= 0) { doi[h.ma] = n; demDoi++; }
      });
      if (!demDoi || !window.MAY_CHU) return;
      // Không ghi được vào CSDL (không phải BGH/quản trị, hoặc RPC lỗi): nhãn từng
      // dòng VẪN đổi theo kết quả đếm cho khớp icon 📂 — thầy Chung 30/10 thấy thư
      // mục đã có tệp mà nhãn vẫn "Chưa có". Chỉ đổi trên màn, không đụng dữ liệu.
      function nhanTheoDrive() {
        if (!conSong()) return;
        $$('#lp-than tr[data-ma]').forEach(function (tr) {
          var ma = tr.getAttribute('data-ma');
          if (doi[ma] == null) return;
          var tt = doi[ma] > 0 ? 'co' : 'chua';
          var st = $('.st', tr);
          if (st) { st.className = 'st st-' + tt; st.textContent = ST_LABEL[tt]; }
        });
      }
      // Người không phải BGH/quản trị: không gửi lệnh ghi — máy chủ (la_admin) từ chối (mục 100).
      if (!laQuanTriApp()) { nhanTheoDrive(); return; }
      window.MAY_CHU.rpc('cap_nhat_tu_drive', { du_lieu: doi }).then(function (r) {
        if (r.error) {
          if (window.console) console.warn('cap_nhat_tu_drive:', r.error);
          nhanTheoDrive();
          return;
        }
        // CSDL chưa chạy sql/62: RPC cũ chỉ nâng và trả về MỘT CON SỐ. Khi đó
        // KHÔNG hạ badge trên màn (màn phải khớp CSDL) và nói thật là đang lùi.
        var cuKy = (typeof r.data === 'number');
        var soNang = cuKy ? Number(r.data) : Number((r.data && r.data.nang) || 0);
        var soHa = cuKy ? 0 : Number((r.data && r.data.ha) || 0);
        // Dữ liệu trên máy cập nhật KHÔNG cần chốt conSong: máy chủ đã ghi
        // thật rồi, bộ nhớ phải khớp theo dù người dùng đã mở màn khác.
        ds.forEach(function (h) {
          if (doi[h.ma] == null) return;
          var ttMoi = doi[h.ma] > 0 ? 'co' : 'chua';
          if (cuKy && ttMoi === 'chua') return;   // RPC cũ không hạ
          h.tt = ttMoi;
          if (window.HS_BAN_GHI && window.HS_BAN_GHI[h.ma]) window.HS_BAN_GHI[h.ma].trang_thai = ttMoi;
        });
        // Nhãn trạng thái từng dòng khớp theo data-ma nên tự an toàn; riêng
        // dải tổng là ô dùng chung giữa các bộ phận — phải còn sống mới ghi.
        $$('#lp-than tr[data-ma]').forEach(function (tr) {
          var ma = tr.getAttribute('data-ma');
          if (doi[ma] == null) return;
          if (cuKy && doi[ma] === 0) return;
          var tt = doi[ma] > 0 ? 'co' : 'chua';
          var st = $('.st', tr);
          if (st) { st.className = 'st st-' + tt; st.textContent = ST_LABEL[tt]; }
        });
        if (conSong()) {
          var d2 = demTrangThai(ds);
          var big = $('.sheet-sum .big');
          if (big) big.textContent = d2.co + '/' + d2.tong + ' hồ sơ đã có tệp';
        }
        // Vẽ lại CẢ lưới 5 thẻ bộ phận, không chỉ trang chủ — đóng lớp phủ mà
        // thẻ phía sau còn khoe con số cũ là lại "hai con số kể hai chuyện",
        // đúng cái cảnh thay đổi này sinh ra để diệt (soát đối kháng 26/8).
        veThongKe();
        veHoSo();
        var cau = [];
        if (soNang) cau.push('nâng ' + soNang + ' hồ sơ thành "Đã có"');
        if (soHa) cau.push('hạ ' + soHa + ' hồ sơ về "Chưa có" vì thư mục trống');
        if (cau.length) window.notify('Đã cập nhật theo Drive: ' + cau.join(' · ') + '.');
        if (cuKy) window.notify('CSDL của trường chưa chạy sql/62 nên chưa hạ được trạng thái theo Drive — lời khai cũ vẫn giữ.');
      }).catch(function () { /* lỗi mạng lúc ghi — kết quả quét vẫn nguyên trên màn */ });
    }

    goiLo(0);
  };

  // ── Lớp phủ chi tiết một bộ phận ──
  window.moBoPhan = function (soTT, maChon) {
    var bp = window.BO_PHAN.filter(function (b) { return b.soTT === soTT; })[0];
    if (!bp) return;
    boPhanDangMo = soTT;

    var dsBP = window.HO_SO.filter(function (h) { return bp.hop.indexOf(h.hop) >= 0; });
    var d = demTrangThai(dsBP);

    $('#lp-ic').textContent = String(soTT).padStart(2, '0');
    $('#lp-ic').className = 'ic num';
    $('#lp-tieu-de').textContent = bp.ten;
    $('#lp-phu').textContent = bp.hop.map(function (m) { return (window.HOP[m] || {}).ten; }).join(' · ');

    var hopChon = maChon ? (window.HO_SO.filter(function (h) { return h.ma === maChon; })[0] || {}).hop : null;

    $('#lp-than').innerHTML =
      '<div class="sheet-sum"><div>' +
      '<div class="big">' + d.co + '/' + d.tong + ' hồ sơ đã có tệp</div>' +
      '<div class="sub-chu">' + (window.DA_NOI ? 'Số liệu đọc trực tiếp từ cơ sở dữ liệu' : 'Đang xem dữ liệu mẫu') + '</div>' +
      '</div><div class="sp"></div>' +
      '<button class="nut-kiem-tra" onclick="kiemTraBoPhan(' + soTT + ')">🔄 Kiểm tra ngay</button></div>' +
      '<div id="kq-kiem-tra"></div>' +
      bp.hop.map(function (maHop, i) {
        var hop = window.HOP[maHop];
        // Hồ sơ ĐÃ ĐÓNG không liệt kê trong hộp — thầy Chung 11/10/2026 (bên mầm non): "đã đóng thì đưa vào danh mục làm gì?".
        // Danh sách đã đóng vẫn in ở Biểu mẫu (bieu-mau.js) và vẫn tìm được ở ô tìm kiếm.
        var ds = window.HO_SO.filter(function (h) { return h.hop === maHop && h.tt !== 'da_dong'; });
        var mo = hopChon ? (maHop === hopChon) : (i === 0);
        return '<div class="sub' + (mo ? ' open' : '') + '">' +
          '<div class="sub-head" role="button" tabindex="0"' +
          ' onclick="if(!event.target.closest(\'.sub-word\'))this.parentNode.classList.toggle(\'open\')"' +
          ' onkeydown="if(event.key===\'Enter\'||event.key===\' \'){event.preventDefault();this.parentNode.classList.toggle(\'open\')}">' +
          '<span class="fo">📁</span><b>' + thoatHTML(maHop + '. ' + hop.ten) + '</b>' +
          // Phiếu giao việc = văn bản PHÂN CÔNG: chỉ BGH/quản trị (mục 100).
          (laQuanTriApp()
            ? '<button type="button" class="sub-word" title="Tải phiếu giao việc của hộp này ra Word"' +
              ' onclick="event.stopPropagation();xuatHopWord(\'' + maHop + '\')">📄 Tải file Word</button>'
            : '') +
          '<span class="sub-cnt">' + ds.length + ' hồ sơ</span><span class="sub-arrow">▶</span></div>' +
          '<div class="sub-body"><table class="rec-tbl"><thead><tr>' +
          '<th style="width:120px">Mã hồ sơ</th><th>Tên hồ sơ</th>' +
          '<th style="width:170px">Người phụ trách</th><th style="width:190px;text-align:right">Trạng thái</th></tr></thead>' +
          '<tbody>' + ds.map(function (h) { return dongBang(h, false); }).join('') + '</tbody></table></div></div>';
      }).join('');

    $('#lop-phu').classList.add('on');
    document.body.style.overflow = 'hidden';

    if (maChon) {
      setTimeout(function () {
        var dong = $('#lp-than tr[data-ma="' + maChon + '"]');
        if (dong) { dong.scrollIntoView({ block: 'center' }); dong.classList.add('sang'); }
      }, 60);
    }
  };

  window.dongLopPhu = function () {
    $('#lop-phu').classList.remove('on');
    document.body.style.overflow = '';
    boPhanDangMo = null;
  };

  // Vẽ lại lớp phủ đang mở (sau khi lưu hồ sơ)
  window.veLaiLopPhu = function () {
    if (boPhanDangMo != null) window.moBoPhan(boPhanDangMo);
  };

  // ── Nguyên văn tiêu chí (Mức 1 / Mức 2) trong lớp phủ ──
  window.xemTieuChi = function (ma) {
    var tc = window.TIEU_CHI.filter(function (t) { return t.ma === ma; })[0];
    if (!tc) return;
    boPhanDangMo = null;
    $('#lp-ic').textContent = '✅';
    $('#lp-ic').className = 'ic';
    $('#lp-tieu-de').textContent = 'Tiêu chí ' + tc.ma + (tc.batBuoc ? ' · BẮT BUỘC' : '');
    $('#lp-phu').textContent = tc.ten;
    var mc = window.HO_SO.filter(function (h) { return (h.tc || []).indexOf(ma) >= 0; });
    $('#lp-than').innerHTML =
      (tc.m1
        ? '<div class="lv"><span class="lv-tag">MỨC 1</span><p>' + thoatHTML(tc.m1) + '</p></div>' +
          '<div class="lv"><span class="lv-tag m2">MỨC 2</span><p>' + thoatHTML(tc.m2) + '</p></div>'
        : '<div class="the-thong-bao">Nguyên văn Mức 1 / Mức 2 nạp từ cơ sở dữ liệu sau khi đăng nhập.</div>') +
      '<div class="lv" style="margin-top:16px"><b style="font-size:13.5px">📎 ' + mc.length + ' minh chứng trong kho đang gắn với tiêu chí này</b>' +
      '<div class="ev-list">' + mc.map(function (h) {
        return '<span class="ev">📄 ' + thoatHTML(h.ma + ' · ' + h.ten) + '</span>';
      }).join('') + '</div></div>';
    $('#lop-phu').classList.add('on');
    document.body.style.overflow = 'hidden';
  };

  // ── Ô tìm có gợi ý xổ xuống (kiểu Google) ──
  var GY_DS = [];
  function toDam(chu, kw) {
    var t = boDau(chu), k = boDau(kw);
    var i = k ? t.indexOf(k) : -1;
    if (i < 0) return thoatHTML(chu);
    return thoatHTML(chu.slice(0, i)) + '<mark>' + thoatHTML(chu.slice(i, i + kw.length)) + '</mark>' + thoatHTML(chu.slice(i + kw.length));
  }

  function veGoiY() {
    var o = $('#o-tim-ho-so'), xo = $('#hs-goi-y');
    if (!o || !xo) return;
    var kw = (o.value || '').trim();
    if (kw.length < 2) { xo.classList.remove('hien'); xo.innerHTML = ''; GY_DS = []; return; }
    var k = boDau(kw);

    var gom = [];
    window.HO_SO.forEach(function (h) {
      var tMa = boDau(h.ma), tTen = boDau(h.ten), tCu = boDau(h.maCu);
      var hang = -1;
      if (tTen.indexOf(k) === 0) hang = 0;
      else if (tMa.indexOf(k) === 0) hang = 1;
      else if (tCu.indexOf(k) === 0) hang = 2;
      else if (tTen.indexOf(k) > 0) hang = 3;
      else if (tMa.indexOf(k) > 0 || tCu.indexOf(k) > 0) hang = 4;
      if (hang >= 0) gom.push({ hang: hang, h: h });
    });
    gom.sort(function (a, b) { return a.hang - b.hang || a.h.ma.localeCompare(b.h.ma, 'vi'); });
    GY_DS = gom.slice(0, 8);

    if (!GY_DS.length) {
      xo.innerHTML = '<div class="het">Không có hồ sơ nào khớp "' + thoatHTML(kw) + '".</div>';
      xo.classList.add('hien');
      return;
    }
    xo.innerHTML = GY_DS.map(function (g, idx) {
      var hop = window.HOP[g.h.hop] || {};
      return '<button type="button" class="muc" data-i="' + idx + '">' +
        '<span class="ma">' + toDam(g.h.ma, kw) + '</span>' +
        '<span class="ten">' + toDam(g.h.ten, kw) +
        // Mã cũ đã bỏ khỏi màn hình (21/8/2026) — CHỈ còn nhắc ở đây khi chính
        // từ khóa đang gõ khớp mã cũ, để người tìm bằng mã cũ hiểu vì sao trúng.
        '<span class="phu">' + thoatHTML(hop.ten || '') +
        (g.h.maCu && boDau(g.h.maCu).indexOf(k) >= 0 ? ' · mã cũ ' + toDam(g.h.maCu, kw) : '') +
        '</span></span></button>';
    }).join('');
    xo.classList.add('hien');
    $$('.muc', xo).forEach(function (nut) {
      nut.addEventListener('click', function () {
        var g = GY_DS[+nut.getAttribute('data-i')];
        xo.classList.remove('hien');
        var bp = window.BO_PHAN.filter(function (b) { return b.hop.indexOf(g.h.hop) >= 0; })[0];
        if (bp) window.moBoPhan(bp.soTT, g.h.ma);
      });
    });
  }

  // ── Module 2: Trường chuẩn Quốc gia ──
  // Bản DEMO/chưa đăng nhập; tcqg.js ghi đè window.veManTCQG khi có dữ liệu thật.
  function veTieuChi() {
    if (window.TCQG_SAN_SANG && window.veManTCQG) { window.veManTCQG(); return; }
    var stats = $('#kd-stats');
    if (!stats) return;
    stats.innerHTML =
      '<div class="the-kd navy"><b>—</b><span>Mức hiện tại · đăng nhập để tự đánh giá</span></div>' +
      '<div class="the-kd xanh"><b>15</b><span>tiêu chí · 4 tiêu chuẩn</span></div>' +
      '<div class="the-kd vang"><b>8</b><span>tiêu chí bắt buộc (Điều 5)</span></div>' +
      '<div class="the-kd la"><b>71</b><span>nội hàm cần mô tả hiện trạng</span></div>';
    $('#kd-giai-thich').innerHTML = '';
    $('#kd-thanh').innerHTML = '';
    $('#kd-so-tc').textContent = '(4 tiêu chuẩn)';
    $('#kd-loc').innerHTML = '';
    $('#kd-list').innerHTML = window.TIEU_CHI.map(function (t) {
      var soMC = window.HO_SO.filter(function (h) { return h.tc.indexOf(t.ma) >= 0; }).length;
      return '<div class="tc-hang" onclick="xemTieuChi(\'' + t.ma + '\')">' +
        '<span class="tc-ma">' + t.ma + '</span>' +
        '<span class="tc-ten">' + thoatHTML(t.ten) +
        (t.batBuoc ? ' <span class="tc-bb">BẮT BUỘC</span>' : '') +
        '<small>' + soMC + ' minh chứng trong kho · bấm xem nguyên văn</small></span></div>';
    }).join('');
    $('#kd-chi-tiet').innerHTML =
      '<div class="the-thong-bao"><p style="font-size:14.5px"><b>Đăng nhập để tự đánh giá.</b></p>' +
      '<p style="font-size:13.5px;color:var(--chu-mo);margin-top:6px">Sau khi đăng nhập, thầy cô trong Hội đồng ' +
      'tự đánh giá sẽ chấm Đạt/Không đạt từng mức, mô tả hiện trạng theo 71 nội hàm và gắn mã minh chứng ' +
      'từ kho hồ sơ. Ở chế độ xem thử, bấm một tiêu chí để đọc nguyên văn.</p></div>';
    $('#kd-danh-gia-chung').innerHTML = '';
    $('#kd-bao-cao').innerHTML = '';
  }

  // Cửa sổ "Căn cứ & hướng dẫn" — dùng lại lớp phủ chung
  window.moCanCu = function () {
    $('#lp-ic').textContent = '📘';
    $('#lp-ic').className = 'ic';
    $('#lp-tieu-de').textContent = 'Căn cứ & hướng dẫn';
    $('#lp-phu').textContent = 'Thông tư 57/2026/TT-BGDĐT — hiệu lực từ 07/7/2026';
    $('#lp-than').innerHTML =
      '<div class="lv"><span class="lv-tag">CĂN CỨ PHÁP LÝ</span><p>Thông tư 57/2026/TT-BGDĐT quy định về bảo đảm chất lượng ' +
      'và công nhận trường đạt chuẩn quốc gia đối với cơ sở giáo dục phổ thông, thay thế các Thông tư 17, 18, 19/2018 và 22/2024. ' +
      'Nội dung Mức 1 / Mức 2 hiển thị trong hệ thống là nguyên văn Phụ lục II.</p></div>' +
      '<div class="lv"><span class="lv-tag">CÁCH XẾP MỨC (khoản 3 Điều 5)</span><p>Trường đạt Mức 1 khi 8 tiêu chí bắt buộc ' +
      '(1.3, 1.4, 2.1, 2.2, 3.1, 3.2, 4.1, 4.2) đều đạt Mức 1 và ít nhất 5/7 tiêu chí còn lại đạt Mức 1. ' +
      'Đạt Mức 2 khi 8 tiêu chí bắt buộc đều đạt Mức 2, ít nhất 5/7 tiêu chí còn lại đạt Mức 2 và không tiêu chí nào dưới Mức 1.</p></div>' +
      '<div class="lv"><span class="lv-tag m2">Ý NGHĨA HAI MỨC</span><p>Mức 1: nhà trường đáp ứng yêu cầu tổ chức thực hiện. ' +
      'Mức 2: có minh chứng về việc rà soát, điều chỉnh, cải tiến dựa trên dữ liệu — tự đánh giá tuần tự Mức 1 rồi mới xét Mức 2.</p></div>' +
      '<div class="lv" style="border-left:4px solid var(--canh)"><span class="lv-tag" style="background:var(--canh)">⚠ CHUYỂN TIẾP (khoản 4 Điều 27)</span>' +
      '<p>Từ 07/7/2026 đến hết 31/12/2028, dữ liệu định lượng được dùng để theo dõi, phân tích, cảnh báo và hỗ trợ cải tiến — ' +
      'không được dùng làm căn cứ duy nhất hoặc ngưỡng loại trừ để kết luận không đạt. Kết luận thuộc về Hội đồng tự đánh giá.</p></div>';
    $('#lop-phu').classList.add('on');
    document.body.style.overflow = 'hidden';
  };

  // ── Nhận diện trường ──
  // Một mã nguồn dùng chung cho nhiều trường (xem js/cauhinh.js). Mọi chỗ mang
  // tên trường trong index.html đều điền từ đây, KHÔNG ghi cứng trong HTML.
  // Gọi HAI lần: lúc khởi động, và lại một lần nữa trong du-lieu-sql.js sau khi
  // bảng cau_hinh trên CSDL ghi đè CAU_HINH (CSDL mới là nguồn chuẩn).
  // Gọi từ tcqg.js mỗi lần xếp mức: nhớ kết quả TỰ ĐÁNH GIÁ rồi vẽ lại ô trang
  // chủ. Chỉ nhận kết luận có mức (Đạt Mức 1/2) — "Chưa đánh giá", "Không đạt"
  // thì giữ dấu gạch như cũ, không tự viết thay nhà trường.
  window.capNhatMucTrangChu = function (ketLuan, nam) {
    var m = /Mức\s*([123])/.exec(String(ketLuan || ''));
    window.MUC_TU_DG = m && !/không/i.test(ketLuan) ? { muc: 'Mức ' + m[1], nam: nam || '' } : null;
    datNhanDienTruong();
  };
  function datNhanDienTruong() {
    var C = window.CAU_HINH || {};
    // Biểu trưng trung tính cho cổng chung và bản xem thử. Nhận ra bằng chính
    // C.MA rỗng — hai chỗ đó cố ý không mang mã trường nào.
    // ⚠️ img/truong.jpg ở thư mục gốc LÀ ẢNH SÂN TRƯỜNG THẬT CỦA DIỄN LIÊN —
    //    đừng lấy làm ảnh nền dự phòng chung. Riêng img/logo.png thì từ
    //    20/8/2026 đã là logo Quản trị số dùng chung (trước đó là con dấu
    //    Diễn Liên có in tên trường), nên nay rơi vào đó không còn sai nữa.
    var LOGO_CHUNG = 'img/he-thong.svg';
    var laTrungTinh = !C.MA;
    var anh = laTrungTinh ? LOGO_CHUNG : (C.THU_MUC_ANH || 'img/') + 'logo.png';

    document.title = 'Quản trị số — ' + (C.TEN_TRUONG || '');
    $$('.dien-ten-truong').forEach(function (e) { e.textContent = C.TEN_TRUONG || ''; });
    $$('.dien-dia-chi').forEach(function (e) { e.textContent = C.DIA_CHI_TRUONG || ''; });
    // Chân trang: bản xem thử rút gọn thành "Bản xem thử. Năm học …" (thầy
    // Chung 24/8/2026) — nhãn đầy đủ "không phải trường có thật" vẫn giữ ở
    // đầu trang làm chốt an toàn chống ảnh chụp số liệu mẫu lan đi như thật.
    $$('.chan-dia-chi').forEach(function (e) {
      var dc = C.DIA_CHI_TRUONG || '';
      e.textContent = /^Bản xem thử/.test(dc) ? 'Bản xem thử. ' : (dc ? dc + ' · ' : '');
    });
    $$('.dien-chu-quan').forEach(function (e) { e.textContent = C.DON_VI_CHU_QUAN || ''; });
    var oMuc = document.getElementById('tk-muc-cqg');
    if (oMuc) oMuc.textContent = C.MUC_CHUAN_QG || '–';
    var tuDG = !C.MUC_CHUAN_QG && window.MUC_TU_DG;   // xem capNhatMucTrangChu
    // Nhãn dưới ô mức chuẩn quốc gia. Câu "phấn đấu giữ vững và phát triển" chỉ
    // đúng với trường ĐÃ đạt chuẩn; trường chưa khai mà để câu đó thì thành
    // phần mềm nói hộ một cam kết nhà trường chưa hề đưa ra.
    var oMucNhan = document.getElementById('tk-muc-cqg-nhan');
    if (oMucNhan) {
      oMucNhan.textContent = C.MUC_CHUAN_QG
        ? 'phấn đấu giữ vững và phát triển' : 'mức chuẩn quốc gia';
    }
    // Ô này KHÔNG đếm được từ đâu cả — nhà trường phải tự khai. Để trơ dấu
    // gạch thì người xem tưởng phần mềm hỏng, nên chỉ luôn đường đi bằng lời
    // mách khi rê chuột. Vẫn không bịa chữ "Chưa đạt": để trống trong cấu hình
    // có thể là chưa đạt, mà cũng có thể là chưa ai kịp khai.
    var oMucHop = oMuc && oMuc.closest ? oMuc.closest('.o') : null;
    if (oMucHop) {
      oMucHop.title = C.MUC_CHUAN_QG ? ''
        : 'Chưa khai mức chuẩn quốc gia. Quản trị → ⚙️ Thông tin trường → Mức ĐANG đạt.';
    }
    if (tuDG) {
      if (oMuc) oMuc.textContent = tuDG.muc;
      if (oMucNhan) oMucNhan.textContent = 'tự đánh giá năm học ' + tuDG.nam;
      if (oMucHop) oMucHop.title = 'Kết quả tự đánh giá theo Thông tư 57 (trang Trường chuẩn quốc gia), chưa phải mức được công nhận. Khai mức được công nhận ở Quản trị → ⚙️ Thông tin trường.';
    }

    // Khẩu hiệu: dựng cả dòng ở đây. Trống thì ẩn hẳn, đừng để trơ hai bông lúa.
    var oKh = document.getElementById('dien-khau-hieu');
    if (oKh) {
      oKh.innerHTML = C.SLOGAN ? '🌾 <span id="dien-slogan"></span> 🌾' : '';
      if (C.SLOGAN) oKh.querySelector('#dien-slogan').textContent = C.SLOGAN;
      oKh.style.display = C.SLOGAN ? '' : 'none';
      // Ẩn dòng khẩu hiệu là ẩn luôn cả khoảng thở dưới tên trường — tên trường
      // cỡ 52px dính sát chữ SỨ MỆNH, chật cứng (Châu Đình 23/8/2026). Báo cho
      // CSS biết để nó trả lại khoảng cách ấy; xem .hero.khong-khau-hieu.
      var oHero = document.getElementById('hero');
      if (oHero) {
        if (C.SLOGAN) oHero.classList.remove('khong-khau-hieu');
        else oHero.classList.add('khong-khau-hieu');
      }
    }

    // Mục tiêu trong câu SỨ MỆNH/MỤC TIÊU: dấu chấm phẩy đi kèm phần chữ, nên
    // trường chưa khai thì câu vẫn liền mạch chứ không cụt.
    var oMt2 = document.getElementById('dien-muc-tieu');
    if (oMt2) {
      oMt2.textContent = C.MUC_TIEU_CHUAN_QG
        ? '; ' + String(C.MUC_TIEU_CHUAN_QG).toLowerCase() : '';
    }

    // Dòng mục tiêu chuẩn quốc gia ở đầu màn Trường chuẩn Quốc gia. Chưa khai
    // mục tiêu thì ẨN HẲN dòng — thà không có còn hơn bịa mục tiêu cho trường.
    var oMt = document.getElementById('dien-muc-tieu-cqg');
    if (oMt) {
      oMt.textContent = C.MUC_TIEU_CHUAN_QG ? '🎖 Mục tiêu: ' + C.MUC_TIEU_CHUAN_QG : '';
      oMt.style.display = C.MUC_TIEU_CHUAN_QG ? '' : 'none';
    }

    // Trường chưa gửi logo riêng → thư mục của trường còn trống, ảnh sẽ hỏng.
    // Bắt sự kiện lỗi để quay về logo chung, đừng để vỡ ảnh trên đầu trang.
    $$('.dien-logo').forEach(function (e) {
      e.onerror = function () { this.onerror = null; this.src = LOGO_CHUNG; };
      e.src = anh;
    });
    // Biểu tượng thẻ + biểu tượng "Thêm vào MH chính":
    // 🔴 KHÔNG gán bừa `anh` vào <link> như <img>: thẻ <link> KHÔNG có onerror,
    //    và apple-touch-icon iOS CHỈ nhận PNG. Bản trước gán thẳng nên:
    //      · bản xem thử/cổng chung → anh là SVG → iOS bỏ qua → icon trên màn
    //        hình chính rơi về CHỮ CÁI ĐẦU tiêu đề — chữ "Q" (thầy Chung gặp
    //        trên iPhone 21/8/2026);
    //      · trường chưa gửi logo (img/<mã>/logo.png chưa có) → 404 → y hệt.
    //    Nay: giữ nguyên bộ mặc định của index.html (he-thong.svg + PNG
    //    bieu-tuong.png); CHỈ khi logo PNG của trường TẢI ĐƯỢC THẬT mới thay.
    if (!laTrungTinh) {
      var thuLogo = new Image();
      thuLogo.onload = function () {
        ['icon', 'apple-touch-icon'].forEach(function (r) {
          var l = document.querySelector('link[rel="' + r + '"]');
          if (l) l.href = anh;   // anh lúc này là …/logo.png — PNG, đã tải được
        });
      };
      thuLogo.src = anh;
    }

    // Ảnh nền dải đầu trang chủ — LỚP TRÊN của hai lớp nền (xem .hero .anh
    // trong style.css). Đặt 'none' thì lộ ra lớp dưới là hình vẽ dùng chung
    // img/nen-hoc-tap.webp, chứ không còn trơ một mảng xanh.
    // Cổng chung và bản xem thử luôn để 'none': img/truong.jpg ở thư mục gốc
    // là ảnh SÂN TRƯỜNG DIỄN LIÊN thật — lấy làm nền cho "Trường Tiểu học
    // Minh Họa" thì hóa ra vừa bịa số liệu vừa mượn ảnh của trường có thật.
    document.documentElement.style.setProperty('--anh-truong',
      laTrungTinh ? 'none' : 'url("' + (C.THU_MUC_ANH || 'img/') + 'truong.jpg")');

    // Các thẻ og:*/twitter:* — xem chú thích trong index.html: bọ đọc thẻ của
    // Zalo/Facebook không chạy JS nên phần này chỉ có tác dụng với trình duyệt.
    var tenDayDu = 'Hệ thống Quản trị số — ' + (C.TEN_TRUONG || '');
    var anhTuyetDoi = location.origin && location.origin !== 'null'
      ? location.origin + location.pathname.replace(/[^/]*$/, '') + anh : anh;
    [['meta[property="og:site_name"]', C.TEN_TRUONG || ''],
     ['meta[property="og:title"]', tenDayDu],
     ['meta[name="twitter:title"]', tenDayDu],
     ['meta[property="og:image:alt"]', 'Logo ' + (C.TEN_TRUONG || '')],
     ['meta[property="og:image"]', anhTuyetDoi],
     ['meta[name="twitter:image"]', anhTuyetDoi]
    ].forEach(function (c) {
      var m = document.querySelector(c[0]);
      if (m) m.setAttribute('content', c[1]);
    });
  }
  window.datNhanDienTruong = datNhanDienTruong;

  // ── Khởi động ──
  // Cấu hình trường nay tải bất đồng bộ (cau-hinh/…), thường về SAU nhịp này —
  // nên phải vẽ lại nhận diện trường khi nó tới. Đây là lần vẽ thứ hai trong ba:
  // (1) lúc này, cấu hình trung tính · (2) khi tải xong tệp cấu hình trường ·
  // (3) sau khi đọc bảng cau_hinh trên CSDL (js/du-lieu-sql.js) — nguồn chuẩn.
  function veLaiTheoCauHinh() {
    datNhanDienTruong();
    var o;
    // Khẩu hiệu và mục tiêu nay do datNhanDienTruong() lo trọn (cả phần ẩn khi
    // trống), đừng ghi đè lại ở đây kẻo mất phần xử lý ô rỗng.
    if ((o = $('#dien-nam-hoc'))) o.textContent = window.CAU_HINH.NAM_HOC || '';
    if (window.DA_NOI && (o = $('#bang-xem-thu'))) o.style.display = 'none';
  }
  if (window.CAU_HINH_SAN_SANG) window.CAU_HINH_SAN_SANG.then(veLaiTheoCauHinh, veLaiTheoCauHinh);

  document.addEventListener('DOMContentLoaded', function () {
    datNhanDienTruong();
    $('#dien-nam-hoc').textContent = window.CAU_HINH.NAM_HOC;
    // Năm bản quyền chân trang: chỉ phụ thuộc lịch, không phụ thuộc cấu hình
    // trường — nên điền MỘT lần ở đây, không vẽ lại trong veLaiTheoCauHinh.
    var oBQ = $('#dien-nam-ban-quyen');
    if (oBQ && window.namBanQuyen) oBQ.textContent = window.namBanQuyen();
    if (window.DA_NOI) {
      $('#bang-xem-thu').style.display = 'none';
    }
    // ⛔ ĐÃ GỠ Ô CHỌN TRƯỜNG khỏi băng xem thử (19/8/2026).
    //    Ô đó là một <select> liệt kê TÊN MỌI TRƯỜNG đang dùng app. Chốt cũ
    //    chỉ giấu nó trên cổng chung, tưởng thế là đủ — không đủ:
    //    mở trang của một trường kèm ?truong=11217 là trang tự mở khóa
    //    (trường đó chưa nối CSDL nên DA_NOI=false) và bày ra ô chọn có đủ
    //    "Trường Tiểu học Diễn Liên" và "Trường Tiểu học Châu Đình". Ai cũng
    //    làm được, không cần biết gì trước; mã trường của Sở là 5 chữ số và
    //    bảng 513 trường thì công khai, nên dò ra hết trường nào đang dùng app.
    //    Đúng thứ nguyên tắc "mỗi trường thấy một mình mình" cấm.
    //    Đổi trường nay đi bằng ?truong=<mã> hoặc màn khai mã ở cổng chung —
    //    cả hai đều đòi người dùng BIẾT TRƯỚC mã, không bày sẵn danh sách.
    //    Hai hàm dsTruongDeChon() / htmlChonTruong() cũng đã bỏ hẳn khỏi
    //    cauhinh.js — muốn liệt kê được thì phải có danh sách trường trong mã
    //    nguồn, mà đó đúng là thứ vừa gỡ đi.

    $$('nav.menu button').forEach(function (b) {
      b.addEventListener('click', function () { chuyenManHinh(b.getAttribute('data-di')); });
    });

    // ── Nhảy thẳng theo #hash trên địa chỉ (vd …/#cbgv) ──
    // Dùng cho "đầu mục trỏ": hai đầu H08 gắn link .../#cbgv — bấm 📂 là vào
    // thẳng trang Hồ sơ CBGV – NV, nơi có nút thư mục Drive của TỪNG giáo viên
    // (chốt của thầy Chung 25/8/2026 — giáo án, sổ chủ nhiệm nằm trong thư mục
    // cá nhân, không bắt nộp lại). PHẢI kiểm màn hình tồn tại rồi mới chuyển:
    // chuyenManHinh với mã lạ sẽ tắt hết mọi màn — trang trắng không lời.
    (function () {
      var mh = (location.hash || '').replace(/^#/, '');
      if (mh && document.getElementById('mh-' + mh)) chuyenManHinh(mh);
    })();
    $('#o-tim-ho-so').addEventListener('input', function () { tuKhoa = this.value; veGoiY(); veHoSo(); });
    $('#chon-trang-thai').addEventListener('change', function () { locTT = this.value; veHoSo(); });
    document.addEventListener('click', function (e) {
      var xo = $('#hs-goi-y');
      if (xo && !e.target.closest('.hang-tim')) xo.classList.remove('hien');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && $('#lop-phu').classList.contains('on')) window.dongLopPhu();
    });

    veTatCa();
  });

  function veTatCa() { veThongKe(); veHoSo(); veTieuChi(); }
  window.veTatCa = veTatCa;
  // Đếm quy mô chạy RỜI, xong sau khi kho hồ sơ đã vẽ — nó gọi lại đúng hàm này
  // để điền hai ô lớp / học sinh, khỏi vẽ lại cả bảng danh mục.
  window.veThongKe = veThongKe;
})();

;} catch (e) { console.error("[goi.min.js] Lỗi khi nạp js/app.js:", e); }
